import { Component, HostListener, Renderer2  } from '@angular/core';

import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from './services/loader.service';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaintenanceBannerComponent } from './components/maintenance-banner/maintenance-banner.component';
declare var $:any;
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NgxUiLoaderModule, MaintenanceBannerComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Transfer Center';
  getLang:any ='';

  isRefreshed = false;
    @HostListener('window:beforeunload', ['$event'])
    onBeforeUnload(event: Event) {
        console.log('isrefreshed', this.isRefreshed);
        if (!this.isRefreshed) {
            console.log('Page refreshed----------');
        }
        else
        {
          console.log('Page not refreshed--------');
        }
    }

  constructor(
    public translate: TranslateService,
    public loaderService: LoaderService,
    private renderer: Renderer2
  ) {


    // window.addEventListener('keydown', event => {
    //     console.log('Key Pressed ==>', event, this.isRefreshed);
    //     console.log('pressed key is--------->',event.key);
    //     if (event.key == 'r' || event.key == 'F5'){
          
    //       this.isRefreshed = true;
    //     } 
    // });

    // if(window) {
    //   window.console.log = function() {};
    // }

    // const browserLang:any = translate.getBrowserLang();
    // translate.addLangs(['en', 'jp']);
    translate.addLangs(['jp']);
    translate.setDefaultLang('jp'); 
    // translate.setDefaultLang(browserLang); 

    this.getLang = localStorage.getItem('lang');

    if(this.getLang == '' || this.getLang == null){
      translate.use('jp'); 
    }
    else {
      translate.use(this.getLang);
    }

    
    
    
    
    
  }

  ngOnInit(): void {
    // $('.closeBtn').on('click', function () {
    //   $('.update-notification').slideToggle();
    // })

    // setTimeout(()=>{                           // <<<---using ()=> syntax
    //   $('.update-notification').slideToggle();
    // }, 30000);
  }
}
